import React from 'react';
import { SiteKitIconButton } from '../../SiteKitIcon/SiteKitIconButton/SiteKitIconButton';
import HStack from '../../../../HStack/HStack';
import Box from '../../../../Box/Box';
import VStack from '../../../../VStack/VStack';
import { useSiteKit } from '../../SiteKitContext/SiteKitContext';

// Subcomponents
import { SiteKitSignPostContextSelectorTrigger } from './SiteKitSignPostContextSelectorTrigger';
import { SiteKitSignPostSubtitle } from './SiteKitSignPostSubtitle';
import { SiteKitSignPostTitle } from './SiteKitSignPostTitle';

// Exports
interface SiteKitSignPostProps {
  children: React.ReactNode;
}
const SiteKitSignPost = ({ children }: SiteKitSignPostProps) => {
  const { isMobileOrTablet, sidebarOpen, setSidebarOpen } = useSiteKit();
  return (
    <HStack alignY="center" spacing="none">
      {(!sidebarOpen || isMobileOrTablet) && (
        <Box right="xsmall">
          <SiteKitIconButton
            data-testid="menu-toggle-button"
            label="Menu"
            icon="bars"
            theme="light-secondary"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          />
        </Box>
      )}
      <VStack spacing="none">{children}</VStack>
    </HStack>
  );
};
SiteKitSignPost.ContextSelectorTrigger = SiteKitSignPostContextSelectorTrigger;
SiteKitSignPost.Subtitle = SiteKitSignPostSubtitle;
SiteKitSignPost.Title = SiteKitSignPostTitle;

SiteKitSignPost.displayName = 'SiteKit.Header.SignPost';

export { SiteKitSignPost, SiteKitSignPostProps };
